export const requestedClarificationsHeaders = [
  {
    value: 'person.id',
    label: 'Tymber',
    sortable: false,
  },
  {
    value: 'shift.name',
    label: 'Směna',
    sortable: false,
  },
  {
    value: 'shift.start_time',
    label: 'Datum směny',
    sortable: true,
  },
  {
    value: 'excuses.reviewed_at',
    label: 'Datum žádosti',
    sortable: false,
  },
  {
    value: 'bonusActions',
    label: '',
    sortable: false,
  },
];
